document.addEventListener('DOMContentLoaded', function() {
    let swatches = document.querySelectorAll('.grid-product__swatch');
    swatches.forEach(function(swatch) {
        swatch.addEventListener('mouseover', function() {
            swatch.parentElement.querySelector('.grid-product__swatch--active').classList.remove('grid-product__swatch--active');
            swatch.classList.add('grid-product__swatch--active');
        });

        swatch.addEventListener('mouseout', function() {
            swatch.classList.remove('grid-product__swatch--active');
            let activeSwatch = swatch.parentElement.querySelector('.grid-product__swatch[data-active="true"]');
            if (activeSwatch) {
                activeSwatch.classList.add('grid-product__swatch--active');
            }
        });
    });
});